import React from 'react';
import { connect } from 'react-redux';
import '../../../assets/styles/components/cash-account-mobile.scss';
import { Converter } from '@/helpers/functions';
import { getSafe } from '@/helpers/global';
import { colorBindingTypes as colorTypes } from '@/constants/color-binding-type';

class CashAccountMobile extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  render() {
    const { language, topPart, contentExpand , cashAccountData, portfolioData } = this.props;
    return (
      <React.Fragment>
        <div className="cash-account-container">
          {topPart && <div className="grids-top-bar">
            <div className="grid-item-flex">
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_net_assets)} ({cashAccountData.ccy})</div>
                <div className="item-value">{cashAccountData.value}</div>
              </div>
            </div>
            <div className="grid-item-flex">
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_today_PL)}</div>
                <div className="item-value"  style={Converter.colorMapping(colorTypes.BUYING_POWER, getSafe(() => cashAccountData.todayDelayedProfitAndLoss.replaceAll(settingConfigs.PRICE.thousandSeparator, ''), 0))}>
                  <span>
                    {cashAccountData.todayDelayedProfitAndLoss ?
                    (Number(cashAccountData.todayDelayedProfitAndLoss > 0) ? `+${cashAccountData.todayDelayedProfitAndLoss}` : 
                    (Number(cashAccountData.todayDelayedProfitAndLoss) === 0 ? `${cashAccountData.todayDelayedProfitAndLoss}` : `${cashAccountData.todayDelayedProfitAndLoss}`)) :'-'}
                  </span>
                  <span>(-)</span>
                </div>
              </div>
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_position_PL)}</div>
                <div className="item-value"  style={Converter.colorMapping(colorTypes.UP_DOWN, getSafe(() => portfolioData.floatingPL.replaceAll(settingConfigs.PRICE.thousandSeparator, ''), 0))}>
                  <span>
                    {portfolioData.floatingPL ?
                    (Number(portfolioData.floatingPL.replaceAll(',','')) > 0 ? `+${portfolioData.floatingPL}` : 
                    (Number(portfolioData.floatingPL) === 0 ? `${portfolioData.floatingPL}` : `${portfolioData.floatingPL}`)) :'-'}
                  </span>
                  <span>
                    ({portfolioData.floatingPLPercent ?
                    (Number(portfolioData.floatingPLPercent.replace('%','')) > 0 ? `+${portfolioData.floatingPLPercent}` : 
                    (Number(portfolioData.floatingPLPercent.replace('%','')) === 0 ? `-${portfolioData.floatingPLPercent}` : `${portfolioData.floatingPLPercent}`)) : `-`})
                  </span>
                </div>
              </div>
            </div>
          </div>}
          {contentExpand && <div className="grids-content">
            <div className="grid-item-flex">
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_market_value)}</div>
                <div className="item-value" style={Converter.colorMapping(colorTypes.MARGIN)}>{cashAccountData.marketValue}</div>
              </div>
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_hold_amount)}</div>
                <div className="item-value" style={Converter.colorMapping(colorTypes.HOLD_AMOUNT)}>{cashAccountData.holdAmount}</div>
              </div>
            </div>
            <div className="grid-item-flex">
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_buying_power)}</div>
                <div className="item-value" style={Converter.colorMapping(colorTypes.BUYING_POWER, cashAccountData.buyingPower)}>{cashAccountData.buyingPower}</div>
              </div>
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_margin_Value)}</div>
                <div className="item-value">{cashAccountData.marginValue}</div>
              </div>
            </div>
            <div className="grid-item-flex">
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_pending_balance)}</div>
                <div className="item-value">{cashAccountData.pendingBal}</div>
              </div>
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_withdrawable_balance)}</div>
                <div className="item-value">{cashAccountData.withdrawableBal}</div>
              </div>
            </div>
            <div className="grid-item-flex">
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_settled_balance)}</div>
                <div className="item-value">{cashAccountData.settledBalance}</div>
              </div>
            </div>
            <div className="grid-item-flex">
              <div className="item-flex">
                <div className="item-label">{getSafe(() => language.current_account_ledger_balance)}</div>
                <div className="item-value">{cashAccountData.ledgerBal}</div>
              </div>
            </div>
          </div>}
        </div>
      </React.Fragment>
    )
  }
}

export default connect(
  state => ({
    language: state.app.language
  })
)(CashAccountMobile)
